import React, { useEffect } from 'react';

/**
 * Modal con los Términos y Condiciones y Aviso de Privacidad Simplificado
 * para la dinámica interactiva "FanCam en Vivo" (SelfieFan).
 */
const LegalTermsModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          color: '#212529',
          borderRadius: '12px',
          width: '100%',
          maxWidth: '650px',
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
          overflow: 'hidden',
          animation: 'fadeIn 0.2s ease-out',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Encabezado */}
        <div
          style={{
            padding: '1rem 1.25rem',
            borderBottom: '1px solid #dee2e6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#f8f9fa',
          }}
        >
          <div>
            <h5 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 700, color: '#038244' }}>
              Términos y Aviso de Privacidad
            </h5>
            <small style={{ color: '#6c757d', fontWeight: 600 }}>Dinámica Interactiva "FanCam en Vivo"</small>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              lineHeight: 1,
              cursor: 'pointer',
              color: '#6c757d',
              padding: '0.25rem 0.5rem',
            }}
            aria-label="Cerrar"
          >
            &times;
          </button>
        </div>

        {/* Cuerpo con Scroll */}
        <div
          style={{
            padding: '1.25rem',
            overflowY: 'auto',
            fontSize: '0.875rem',
            lineHeight: '1.6',
            color: '#333333',
            textAlign: 'justify',
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '1.25rem' }}>
            <h6 style={{ fontWeight: 800, textTransform: 'uppercase', marginBottom: '0.25rem', color: '#111' }}>
              TÉRMINOS Y CONDICIONES Y AVISO DE PRIVACIDAD SIMPLIFICADO
            </h6>
            <span style={{ fontWeight: 700, color: '#038244' }}>DINÁMICA INTERACTIVA "FANCAM EN VIVO"</span>
          </div>

          <h6 style={{ fontWeight: 700, color: '#038244', marginTop: '1rem' }}>
            1. RESPONSABLES Y ALCANCE DE LA DINÁMICA
          </h6>
          <p>
            La presente dinámica interactiva es operada y provista tecnológicamente por Five Digital Minds, S.A.S. a través de su plataforma Interaktia (en adelante, "El Desarrollador"), en coordinación operativa con Spins (en adelante, "El Operador").
          </p>
          <p>
            Esta activación corresponde a una prueba tecnológica piloto de interacción digital en tiempo real. El participante reconoce y acepta expresamente que el club deportivo anfitrión, el club visitante, la liga deportiva correspondiente, los patrocinadores del evento y el recinto deportivo sede no son operadores, organizadores, copropietarios ni administradores de la plataforma, quedando liberados de cualquier responsabilidad civil, mercantil, administrativa o derivada de derechos de autor e imagen relacionada con la presente dinámica.
          </p>

          <h6 style={{ fontWeight: 700, color: '#038244', marginTop: '1rem' }}>
            2. CONSENTIMIENTO ELECTRÓNICO Y DERECHOS DE IMAGEN
          </h6>
          <p>
            De conformidad con los artículos 1803 del Código Civil Federal, 89 y posteriores del Código de Comercio, así como los artículos 87 y 88 de la Ley Federal del Derecho de Autor (LFDA), al marcar la casilla de verificación (checkbox) y pulsar el botón de envío en la plataforma, El Participante manifiesta y consiente expresamente lo siguiente:
          </p>
          <ul style={{ paddingLeft: '1.25rem' }}>
            <li><strong>a) Capacidad legal:</strong> Ser mayor de 18 años y encontrarse en pleno uso de sus facultades legales.</li>
            <li><strong>b) Titularidad y anuencia:</strong> Ser el autor o poseer la legítima disposición del material capturado, y contar con la autorización previa, expresa y voluntaria de todas las personas que aparezcan en la fotografía para su captación, transmisión y exhibición pública.</li>
            <li><strong>c) Menores de edad:</strong> En caso de que en la imagen aparezcan niñas, niños o adolescentes, quien remite la fotografía declara bajo protesta de decir verdad ser su madre, padre o tutor legal con patria potestad vigente, consintiendo de forma libre, informada y expresa la proyección de su imagen. Si no se cuenta con dicha representación legal sobre la totalidad de los menores presentes en la toma, el participante debe abstenerse estrictamente de remitir el material.</li>
            <li><strong>d) Autorización de uso a título gratuito:</strong> Otorga a El Desarrollador y a El Operador una licencia temporal, no exclusiva, territorialmente limitada al recinto y estrictamente a título gratuito para proyectar, transmitir, comunicar públicamente y reproducir la fotografía en las pantallas monumentales y circuitos cerrados del recinto durante el desarrollo del evento deportivo. El Participante renuncia formalmente a exigir cualquier cobro, regalía o contraprestación presente o futura.</li>
            <li><strong>e) Cláusula de indemnidad:</strong> El Participante se compromete a mantener en paz y a salvo (indemne) a El Desarrollador, a El Operador, a los clubes deportivos y al recinto frente a cualquier reclamación, queja o demanda que terceros pudieran entablar con motivo de la autoría o el derecho a la propia imagen derivado del archivo enviado.</li>
          </ul>

          <h6 style={{ fontWeight: 700, color: '#038244', marginTop: '1rem' }}>
            3. TRATAMIENTO DE DATOS PERSONALES Y CICLO DE VIDA DEL ARCHIVO (LFPDPPP)
          </h6>
          <p>
            En estricto apego a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), su Reglamento y los Lineamientos del INAI:
          </p>
          <ul style={{ paddingLeft: '1.25rem' }}>
            <li><strong>a) Datos tratados y metadatos técnicos:</strong> La plataforma opera de forma no identificada. No se solicitan ni almacenan nombres, números telefónicos, correos electrónicos, cuentas de redes sociales ni ubicaciones geográficas. El único dato objeto de tratamiento es la imagen remitida. Cualquier metadato técnico accesorio generado por el dispositivo móvil (como etiquetas EXIF o marcas de cámara) no es indexado, no se asocia a perfiles de usuario y se destruye de manera simultánea e irreversible con el archivo de imagen.</li>
            <li><strong>b) Finalidad del tratamiento:</strong> La imagen se utiliza con el fin exclusivo de someterse a moderación de contenido y, en su caso, proyectarse en las pantallas del recinto durante el evento.</li>
            <li><strong>c) Destrucción y purga irreversible:</strong> Toda imagen enviada residirá temporalmente en búferes o almacenamiento operativo cifrado y será eliminada, purgada y destruida de forma definitiva, automática e irreversible una vez concluido el encuentro deportivo. Ningún archivo visual se respaldará o conservará en servidores tras el cierre de la dinámica.</li>
            <li><strong>d) Datos disociados y telemetría:</strong> De conformidad con el artículo 3, fracción VIII de la LFPDPPP, las métricas técnicas resultantes (marcas de tiempo de aceptación mediante casilla, marcas de tiempo de moderación, identificadores de sesión aleatorios y estatus de proyección o descarte) constituyen registros irreversiblemente disociados que imposibilitan la identificación de personas, conservándose únicamente para fines de auditoría técnica, seguridad y estabilidad del sistema.</li>
            <li><strong>e) Almacenamiento local del navegador:</strong> El aplicativo podrá almacenar variables locales no invasivas (Local/Session Storage) en el navegador del dispositivo con el único objetivo técnico de regular el tiempo de espera entre envíos sucesivos (intervalo de 2 minutos), previniendo saturación de red o ataques de denegación de servicio. Estas variables no ejecutan seguimiento publicitario ni rastreo entre sitios web.</li>
          </ul>

          <h6 style={{ fontWeight: 700, color: '#038244', marginTop: '1rem' }}>
            4. MODERACIÓN EDITORIAL Y DERECHO DE EXCLUSIÓN
          </h6>
          <p>
            La recepción de la imagen no confiere derecho alguno a su proyección pública. Todo el material remitido pasa por un filtro de moderación humana en tiempo real. El Desarrollador y El Operador se reservan la facultad exclusiva y discrecional de aprobar o descartar cualquier material sin previo aviso. Serán descartadas de inmediato aquellas fotografías que:
          </p>
          <ul style={{ paddingLeft: '1.25rem' }}>
            <li>Muestren gestos obscenos, violencia, consumo de sustancias prohibidas o contenido de carácter sexual explícito o sugerente.</li>
            <li>Contengan leyendas ofensivas, lenguaje de odio o discriminación por motivos de género, raza, religión o preferencia sexual.</li>
            <li>Exhiban marcas comerciales o signos distintivos no autorizados por la organización del evento.</li>
            <li>Atenten contra la sana convivencia, la moral pública o los reglamentos internos del recinto.</li>
            <li>Las imágenes no seleccionadas serán igualmente destruidas al concluir el evento conforme al punto 3.</li>
          </ul>

          <h6 style={{ fontWeight: 700, color: '#038244', marginTop: '1rem' }}>
            5. ATENCIÓN Y CONTACTO
          </h6>
          <p>
            En virtud de que los archivos de imagen son eliminados de forma definitiva e irreversible al término del evento deportivo y que el sistema no almacena datos de contacto directo, las aclaraciones técnicas y el ejercicio de derechos ARCO (Acceso, Rectificación, Cancelación y Oposición) aplican durante la vigencia temporal de la dinámica en vivo. Para cualquier solicitud o aclaración antes de la purga técnica definitiva, el canal de atención es:
          </p>
          <p style={{ fontWeight: 600, color: '#038244' }}>
            Correo de contacto: <a href="mailto:contacto@interaktia.com" style={{ color: '#038244' }}>contacto@interaktia.com</a>
          </p>
        </div>

        {/* Pie de modal */}
        <div
          style={{
            padding: '0.75rem 1.25rem',
            borderTop: '1px solid #dee2e6',
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: '#f8f9fa',
          }}
        >
          <button
            type="button"
            className="Btn__Adsl--Red"
            style={{ backgroundColor: '#038244', padding: '8px 24px', fontSize: '0.9rem' }}
            onClick={onClose}
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export { LegalTermsModal };
